import { render, staticRenderFns } from "./GameCenter.vue?vue&type=template&id=b341f22e&scoped=true&"
import script from "./GameCenter.vue?vue&type=script&lang=js&"
export * from "./GameCenter.vue?vue&type=script&lang=js&"
import style0 from "./GameCenter.vue?vue&type=style&index=0&id=b341f22e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b341f22e",
  null
  
)

export default component.exports